import type { ConversationTarget } from './conversation'

/**
 * Registry of conversation threads currently mounted on screen, keyed by a
 * stable per-instance id. A thread can be opened in more than one place at once
 * — the phone panel (URL-driven) and an embedded view such as the shipment
 * sidebar chat tab (target-prop-driven). The realtime handler reads this to know
 * which open threads an inbound event should refresh, since it can't see the
 * embedded views' target props directly.
 */
const openThreads = new Map<string, ConversationTarget>()

export function registerOpenThread(
  id: string,
  target: ConversationTarget,
): void {
  openThreads.set(id, target)
}

export function unregisterOpenThread(id: string): void {
  openThreads.delete(id)
}

/** All currently-mounted conversation targets (deduped by instance, not value). */
export function getOpenThreads(): ConversationTarget[] {
  return [...openThreads.values()]
}
